// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app_3cl75","tabs":"App_tabs_3nAyE","vue":"App_vue_33jpc","svelte":"App_svelte_3HLhG","editor":"App_editor_1vuCM"};